export const environment = {
  production: false,
  pg_Archive_enabled: false,
  mockAuthentication: true,
  mockUser: 'onafriq',
  mockPassword: 'onafriq',
  jwtSecret: 'secret1234213',
  ENCRYPTION_KEY_256: 'C4CB6A8CBE79E722D6B24B3C354A3',
  jwtClaims: { permissions: 'admin' },
  productID: 'c92d2147-8103-4a4d-8d8f-8bd02aa7dfcb',
  ENCRYPTION_KEY_URI: 'BUw1EW/ZtqeDHwXrzGNgLovqqvOopDo4RMjNDCLT0YM=',
  uri: 'https://papiui-v2.dev.apionafriq.com/login',
  apiUrl:
    'https://papiwebservice.dev.apionafriq.com/PortalWebService/PartnerPortal',
  apiUrlV2:'https://papiportalwebservice.dev.apionafriq.com/PartnerPortal',
  notificationUrl:
    'https://papinotification.dev.apionafriq.com/NotificationWebService',
  customerReportUrl: 'http://178.159.3.134:8080/MfsCustomerReportWebService',
  homeUrl: 'https://staging.onboarding.apimfsafrica.com',
};
